import React, { useEffect, useState, memo, forwardRef } from 'react';
import PropTypes from 'prop-types';

const Icon = memo(
  forwardRef(
    (
      {
        size = 24,
        name,
        color = 'currentColor',
        className = null,
        displaySize = null,
        onClick = null
      },
      forwardedRef
    ) => {
      const [LoadedIcon, setLoadedIcon] = useState(null);
      useEffect(() => {
        const loadIcon = async () => {
          const { chunkMaker } = await import(
            /* webpackChunkName: "SvgIcons" */
            /* webpackPreload: true */
            './chunkMaker'
          );
          const result = await chunkMaker(size, name);
          setLoadedIcon(result);
        };

        loadIcon();
      }, [name, size]);

      if (!LoadedIcon) return null;

      return (
        <LoadedIcon.ReactComponent
          ref={forwardedRef}
          onClick={onClick}
          color={color}
          className={className}
          width={displaySize ?? size}
          height={displaySize ?? size}
          style={{ display: 'inline-flex', flexShrink: 0 }}
        />
      );
    }
  )
);

Icon.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  color: PropTypes.string,
  displaySize: PropTypes.number,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf([16, 20, 24, 48])
};

export { Icon };
